<script>
import LoginForm from './components/LoginForm.vue'
import BaseResource from './resources'

export default {
    name: 'App',
    components: {
        LoginForm
    },
    computed: {
        classes() {
            let classes = ['app-wrapper'].concat(this.$store.getters.wrapperClasses)

            if (!this.$store.getters.navIsClear) {
                classes.push('nav-clear')
            }

            return classes
        },
    },
    methods: {
        onLogin() {
            this.$refs.loginModal.hide()
        },
    },
    mounted() {
        if (this.$store.getters.token) {
            this.$store.dispatch('getUserPermissions')
        }

        // BaseResource.client.tokenWillExpire = () => {
        //     this.$refs.loginModal.show()
        // }
    },
}
</script>

<template>
    <div :class="classes">
        <router-view name="nav" />
        <router-view name="body" class="app-body" />
        <router-view name="footer" />

        <!-- <b-modal ref="loginModal" title="Log In" centered hide-footer no-fade>
            <login-form @success="onLogin" />
        </b-modal> -->
    </div>
</template>

<style lang="scss">
.app-wrapper {
    //min-height: 100%;
    background-color: #fff;
}

.app-body {
    padding-bottom: 3rem;
}

.vf-field-invalid-required {
    legend::after {
        content: '*';
        color: red
    }
}

.full-blue-page {
    background: linear-gradient(135deg, #333f8c 0%, #3a96cc 100%);
    height: 100%;
}
</style>
